import { render, staticRenderFns } from "./NicheOrder.vue?vue&type=template&id=7dad58dc&scoped=true"
import script from "./NicheOrder.vue?vue&type=script&lang=js"
export * from "./NicheOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dad58dc",
  null
  
)

export default component.exports